module.exports = __webpack_public_path__ + "static/PSS-icon-06-5ad3dded19fc18506bd98b3d5d19c1ac.png";